<template>
  <div>
    <form class="form-horizontal">
      <fieldset>
        <legend>{{ $t('filter') }}</legend>
        <div class="row">
          <div class="col-md-6">
            <div class="row form-group">
              <label class="col-form-label col-md-5"></label>
              <div class="col-md-5">
                <a-radio-group
                  v-model="acStatusId"
                  size="small"
                  @change="$emit('acStatusChange')"
                >
                  <a-radio-button :value="1">
                    {{ $t('studentScoringEntry.current') }}
                  </a-radio-button>
                  <a-radio-button :value="2">
                    {{ $t('studentScoringEntry.history') }}
                  </a-radio-button>
                </a-radio-group>
              </div>
            </div>
            <div class="row form-group">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringEntry.className')
              }}</label>
              <div class="col-md-5">
                <a-select
                  v-model="model.class_id"
                  style="width: 100%; height: 35px"
                  :show-search="true"
                  option-filter-prop="children"
                  :filter-option="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :options="classList"
                  @change="onClassChange"
                ></a-select>
              </div>
            </div>
            <div class="row form-group">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringComponentEntry.subject')
              }}</label>
              <div class="col-md-5">
                <a-select
                  v-model="model.subject_id"
                  style="width: 100%; height: 35px"
                  :show-search="true"
                  option-filter-prop="children"
                  :filter-option="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :options="subjects"
                ></a-select>
              </div>
            </div>
            <div class="row form-group">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringComponentEntry.scoringCycle')
              }}</label>
              <div class="col-md-5">
                <a-select
                  style="width: 100%"
                  v-model="model.scoring_cycle_id"
                  @change="scoringCycleChange"
                >
                  <a-select-option
                    v-for="(s, index) in scoringCycle"
                    :key="index"
                    :value="s.scoring_cycle_id"
                  >
                    {{ s.scoring_cycle_name }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <div class="row form-group">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringComponentEntry.scoringCycleValue')
              }}</label>
              <div class="col-md-5">
                <a-select
                  style="width: 100%"
                  v-model.number="model.cycle_value"
                  v-if="model.scoring_cycle_id == 1"
                >
                  <a-select-option
                    v-for="(month, index) in months"
                    :key="index"
                    :value="index + 1"
                  >
                    {{ month }}
                  </a-select-option>
                </a-select>
                <input
                  v-model.number="model.cycle_value"
                  type="number"
                  class="form-control"
                  readonly
                  v-if="model.scoring_cycle_id !== 1"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row form-group">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringComponentEntry.academicYear')
              }}</label>
              <div class="col-md-5">
                <input
                  type="text"
                  class="form-control"
                  readonly
                  :value="acYearLabel"
                />
              </div>
            </div>
            <div class="row form-group">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringComponentEntry.mainProgram')
              }}</label>
              <div class="col-md-5">
                <input
                  type="text"
                  class="form-control"
                  readonly
                  :value="mainProgramLabel"
                />
              </div>
            </div>
            <div class="row form-group">
              <label class="required col-form-label col-md-5">{{
                $t('studentScoringComponentEntry.academicTerm')
              }}</label>
              <div class="col-md-5">
                <input
                  type="text"
                  class="form-control"
                  readonly
                  :value="acTermLabel"
                />
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'filterComponentScoreEntry',
  props: ['value', 'classOperations', 'validate'],
  data () {
    return {
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ],
      model: {},
      term_order: null,
      subjects: []
    }
  },
  created () {
    this.model = this.value
  },
  computed: {
    scoringCycle () {
      return this.$store.state.studentScoringComponentEntry.scoring_cycles.filter(
        s => s.scoring_cycle_id == 2
      )
    },
    classList () {
      return this.classOperations.map(el => ({
        value: el.class_id,
        label: el.class_name + '|' + el.teacher.full_name_en,
        ac_year_id: el.ac_year_id,
        ac_term_id: el.ac_term_id,
        term_order: el.academic_term.term_order,
        acp_id: el.acp_id,
        acps_id: el.acps_id,
        grade_id: el.grade_id
      }))
    },
    acYearLabel () {
      return this.classOperations
        .filter(c => c.class_id == this.model.class_id)
        .reduce((init, item) => (init = item.academic_year.ac_year), null)
    },
    mainProgramLabel () {
      return this.classOperations
        .filter(c => c.class_id == this.model.class_id)
        .reduce(
          (init, item) => (init = item.main_program.acp_name_foreign),
          null
        )
    },
    acTermLabel () {
      return this.classOperations
        .filter(c => c.class_id == this.model.class_id)
        .reduce((init, item) => (init = item.academic_term.term_name), null)
    },
    acStatusId: {
      get () {
        return this.$store.state.studentScoringComponentEntry.ac_status_id
      },
      set (newValue) {
        this.$store.commit(
          'studentScoringComponentEntry/SET_AC_STATUS',
          newValue
        )
      }
    }
  },
  methods: {
    ...mapActions('studentScoringComponentEntry', ['getGrade']),
    onClassChange (value, option) {
      this.model.subject_id = null
      let grade_id = option.data.props.grade_id
      this.model.acp_id = option.data.props.acp_id
      this.model.acps_id = option.data.props.acps_id
      this.model.ac_year_id = option.data.props.ac_year_id
      this.model.ac_term_id = option.data.props.ac_term_id
      this.model.scoring_cycle_id = null
      this.model.cycle_value = null
      this.term_order = option.data.props.term_order

      this.fetchSubjectByGrade(grade_id)
      // if (grade_id == 1 || grade_id == 2) {
      //   this.noticeByGrade()
      // }
      this.getScoringCycle({ acps_id: option.data.props.acps_id })
    },
    noticeByGrade () {
      const h = this.$createElement
      this.$info({
        title: 'Message',
        content: h('div', {}, [
          h(
            'p',
            'The Current selected class not eligible to entry score component details.'
          )
        ]),
        onOk () {}
      })
    },
    fetchSubjectByGrade (grade_id) {
      // Get Subject By Grade
      this.loading = true
      this.getGrade({ grade_id: grade_id })
        .then(response => {
          this.subjects = response.data[0].grade_subject_has_items.map(el => ({
            value: el.subject_id,
            label: el.subject_name_foreign
          }))
          this.$store.commit('studentScoringComponentEntry/SET_SUBJECTS', this.subjects)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    scoringCycleChange () {
      if (this.model.scoring_cycle_id !== 1) {
        this.model.cycle_value = this.term_order
      } else if (this.model.scoring_cycle_id == 4) {
        this.model.cycle_value = 1
      } else {
        this.model.cycle_value = null
      }
    }
  }
}
</script>
